// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconUser, IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons, PasswordStrength } from '../components';

export default function RegisterClassicMinimal() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Register attempt:', { name, email, password });
  };

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/register"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={(theme) => ({
                width: 48,
                height: 48,
                borderRadius: theme.radius.md,
                background: 'linear-gradient(135deg, var(--mantine-color-cyan-6), var(--mantine-color-teal-5))',
              })}
            >
              <Text size="xl" fw={700} c="white">C</Text>
            </Center>
            <Title order={2} ta="center">Create an account</Title>
            <Text c="dimmed" size="sm" ta="center">
              Start your journey with us today
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Full name"
              placeholder="John Doe"
              leftSection={<IconUser size={16} />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div>
              <PasswordInput
                label="Password"
                placeholder="Create a password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="bar" />}
            </div>

            <PasswordInput
              label="Confirm password"
              placeholder="Confirm your password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={confirmPassword && password !== confirmPassword ? "Passwords don't match" : undefined}
            />

            <Checkbox
              label={
                <Text size="sm">
                  I agree to the <Anchor size="sm">Terms of Service</Anchor> and{' '}
                  <Anchor size="sm">Privacy Policy</Anchor>
                </Text>
              }
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.currentTarget.checked)}
              required
            />

            <Button type="submit" fullWidth disabled={!acceptTerms}>
              Create account
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'github']}
          layout="horizontal"
          variant="outline"
          dividerLabel="Or sign up with"
        />

        {/* Login Link */}
        <Text ta="center" size="sm">
          Already have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/login/simple" fw={500}>
            Sign in
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
